import { useCallback } from "react"
import { useParams } from "react-router-dom"
import { unstable_batchedUpdates } from "react-dom"
import type { BranchFilters, RelationRankData, RouterIdsVO } from "@/api"
import { useSetState } from "ahooks-v2"
import { message } from "antd"
import { createModel } from "hox"
import { useConfigModel, useQuotaToolsModel, useStoreListModel } from "@/models"
// ==============================================
interface IndicatorArgs {
  // 筛选条件数据
  screeningData?: BranchFilters
  // 银行网点层级
  relationRanks: RelationRankData[]
  // 是否是右上角城市下拉引起的定位
  isCitySelectLocation: boolean
  // 菜单key
  menuKey?: string
}

function useIndicator() {
  const { cityId, brandId } = useParams<RouterIdsVO>() as any
  const { getStore } = useStoreListModel()
  const { openQuota, cacheQuota } = useQuotaToolsModel()
  const { currentConfig, industryCategory } = useConfigModel()
  const [state, set] = useSetState<IndicatorArgs>({
    relationRanks: [],
    isCitySelectLocation: false,
  })

  const setAllState = useCallback(
    (value: Partial<IndicatorArgs> | ((prevState: IndicatorArgs) => Partial<IndicatorArgs>)) => {
      set(value)
    },
    [set],
  )

  const showIndicatorStoreDetail = useCallback(
    (code?: string, callback?: (store: any) => void) => {
      if (code) {
        const store = getStore(code)

        if (store) {
          const { unlocked } = store
          if (!unlocked) {
            // 开通单网点
            openQuota(store, cityId, brandId, currentConfig?.singleAuth, true, (result) => {
              if (result) {
                callback?.(store)
              }
            })
            return
          }
          unstable_batchedUpdates(() => {
            // 缓存单网点
            cacheQuota(store)
            // 回调
            callback && callback(store)
          })
        } else {
          message.error(`无法查询到此${industryCategory}数据`)
        }
      } else {
        message.error("没有获取到二级支行code，无法展示图表数据")
      }
    },
    [getStore, brandId, cityId, currentConfig, industryCategory, openQuota, cacheQuota],
  )

  // const closeIndicatorStoreDetail = useCallback(() => {
  //   // 清除所有缓存店铺
  //   clearShopCache()
  //   // 清除缓存网点
  //   setBrandPoiValue(null)
  // }, [clearShopCache, setBrandPoiValue])

  return {
    ...state,
    showIndicatorStoreDetail,
    // closeIndicatorStoreDetail,
    setAllState,
  }
}

export default createModel(useIndicator)
